import { render, staticRenderFns } from "./SimpleDonutMulti.vue?vue&type=template&id=04312676&scoped=true&"
import script from "./SimpleDonutMulti.vue?vue&type=script&lang=js&"
export * from "./SimpleDonutMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04312676",
  null
  
)

export default component.exports